module.exports = __webpack_public_path__ + "img/sj.ecbc9e93.svg";